import React, { useState, useEffect } from 'react';
import './Meet.css';
import img1 from './Images/meet/IMG_20220820_164200.jpg';
// import img2 from './Images/meet/Screenshot 2024-10-29 at 6.45.46 PM.png'
// import doctor1 from './Images/meet/doctor-with-his-arms-crossed-white-background.jpg';
import doctor2 from './Images/meet/IMG-20240912-WA0017.jpg';
// import doctor3 from'./Images/meet/front-view-male-nurse-hospital (1).jpg';
import dental1 from '../home/Images/v1.png';
import dental2 from '../home/Images/IMG20240913134831.jpg';
import dental3 from'../home/Images/IMG_20231201_174221.jpg';
import dental4 from '../home/Images/dental2.png'
// import video from './Images/meet/how.mp4';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {  FaCoffee, FaChild, FaClock, FaRegCheckCircle,FaTv,FaCalendarCheck,FaTag,FaCreditCard, FaMedkit,  } from 'react-icons/fa';

function Meet() {
  const words = [
    "integrity",
    "quality",
    "empathy",
    "gratitude",
    "connection",
    "innovation",
    "efficiency",
  ];
  const [showMore, setShowMore] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Check the screen size on mount and whenever the window is resized
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };

    // Initialize screen size state
    handleResize();

    // Event listener for resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleReadMoreClick = () => {
    setShowMore(!showMore);
  };

  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000); // Change word every 1 second

    return () => clearInterval(intervalId); // Clear interval on component unmount
  }, []);

  
  

const barItems = [
    {
      icon: <FaTv size={40} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={40} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={40} />,
      label: "Parking ",
    },
    {
      icon: <FaCreditCard size={40} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={40} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={40} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={40} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={40} />, label: "Emergency Priority" },
    { icon: <FaClock  size={40} />, label: " Time Management  " },
  ];


  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className='about'>
      <div className="about-sec1">
          <div className="content">
            
            <div className="text-section">
            {/* <h1 className='exceptional'>SECTION1</h1> */}
              <p className="trusted-text"><mark className='domark'>ABOUT BOMBAY DENTAL CLINIC</mark></p>
              <h1 className='exceptional'><mark className='expmrk'>Building lifetime </mark></h1>
              <h1 className='exceptional'><mark className='expmrk'>relationships </mark></h1>
              <h1 className='exceptional'><mark className='expmrk'>through positive </mark></h1>
              <h1 className='exceptional'><mark className='expmrk'>experiences</mark></h1>
<a href="/booknow" ><button className="book-button">BOOK ONLINE</button></a>
              <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a>
</p>

     
          </div>
        </div>
      </div>
      <section className="dentalClinic">
      <div className="about-sec2">
      <h1 className="titlea">
      Serving patients with
      <br/> <span className="empathy">{words[currentWordIndex]}</span>
    </h1>
    <p className="description">
        Our energetic team headed by our Chief Orthodontist Dr Tushita Singh, are trained in providing exceptional service.
        We work by 2 main values:
        {isSmallScreen && showMore && (
          <>
            <br />
            We respect your time and we are working on a stringent no-wait policy at Bombay Dental Company to minimize waiting time for pre-booked appointments for our busy patients.
            <br />
            We believe in transparent and affordable pricing. We highlight only what is necessary and make sure you never get the feeling that dentistry is expensive.
          </>
        )}
        {/* Always show the full text for large screens */}
        {!isSmallScreen && (
          <>
            <br />
            We respect your time and we are working on a stringent no-wait policy at Bombay Dental Company to minimize waiting time for pre-booked appointments for our busy patients.
            <br />
            We believe in transparent and affordable pricing. We highlight only what is necessary and make sure you never get the feeling that dentistry is expensive.
          </>
        )}
      </p>
      <p className="description">
        Find all the dental care you need (and then some) here in our beautiful office, designed for your comfort and rejuvenation.
      </p>

      {isSmallScreen && (
        <button className="read-more-btn" onClick={handleReadMoreClick}>
          {showMore ? 'Read Less' : 'Read More'}
        </button>
      )}
        {/* <div className="video-container" onClick={togglePlay}>
          <video
            ref={videoRef}
            className="video-thumbnail"
            src={video}
            type="video/mp4"
            loop
          
          />
          {!isPlaying && <div className="play-button">&#9658;</div>}
        </div> */}
      </div>

      <div className="sideContent">
        <img
          src={img1}
          alt="Dental professionals"
          className="sideImage"
        />
        <p className="sideText">
          At Bombay Dental Clinic, you are in good hands. With every treatment, we promise to do it right, quickly, and
          for a fair price. And we provide a lifetime warranty on all our work — because it’s the right thing to do.
        </p>
      </div>
    </section>
    <div className="dentistProfile">
    
      <div className="dentistLeft">
        <img 
          src={doctor2}
          alt="Dr. Tushita Singh" 
          className="profileImage" 
        />
      </div>
<div className="horizon">
      <div className="dentistRight">
      <div className="dots"></div>
        <h2 className="name">Dr. Tushita Singh</h2>
        <div className="info">
        <div className="aboutdenstist">
        <p className="question">About Dentist</p>
        <p className="bio">
        Dr. Tushita Singh, our founder, is an Orthodontist with nearly 15 years of experience. After completing her education in Delhi, she trained under Dr. Amit Sachdeva, North India's leader in Invisalign. She has treated over 500 Invisalign cases and is a Gold Invisalign provider for the past five years.

        </p>
        <p className='bio'>With a commitment to "Dental care for all," she founded Bombay Dental Company, offering affordable, cutting-edge dentistry in South Bombay with a no-wait policy.</p>
        </div>
        </div>
     

      <div className="educationRight">
        <div className="educationSection">

          <h3>Career</h3>
         <p className='bio'>
         Dr. Singh's career spans multiple esteemed organizations, including Clove Dental, Axiss Dental Clinics, B L Kapur Super Speciality Hospital, Max Hospitals, Columbia Asia Hospitals, and Manipal Hospital, alongside managing her private practices in Green Park, Dwarka, and Gurgaon. Her experience has deepened her appreciation for the value of time and money, which she brings to her patients.

         </p>

          
          {/* <h3>Hobbies</h3>
         <p className='bio'>Outside of work, Dr. Singh is an avid traveler, skydiver, open-water scuba instructor, and fitness enthusiast, enjoying trekking, cycling, and the outdoors with her young son.
</p> */}
        </div>
        </div>
       </div>
       </div>
   
</div>

{/* <div className="dentistProfile">
     
     <div className="dentistLeft">
       <img 
         src={doctor1}
         alt="Dr. Steven Zervas" 
         className="profileImage" 
       />
     </div>

     <div className="dentistRight">
     <div className="dots"></div>
       <h2 className="name">Dr. Steven Zervas</h2>
       <p className="question">Why dentistry?</p>
       <p className="bio">
         I’m a dentist because it has always been my desire to help people in a healthcare environment. 
         Growing up in my dad’s and uncle’s dental office, I learned early on that dentistry was going to 
         be my path. I love the relationships we build with our patients and our ability to help them live 
         healthier, better lives.
       </p>
       </div>
    

     <div className="educationRight">
       <div className="educationSection">
         <h3>Education</h3>
         <ul>
           <li>BA in Biology and World Religions, Westminster College</li>
           <li>DDS, University of Oklahoma</li>
         </ul>
         
         <h3>Out and about in Denver/Greenwood Village</h3>
         <ul>
           <li>Running in Wash Park</li>
           <li>Concerts at the Mission Ballroom and Red Rocks</li>
           <li>Telemark skiing at Arapahoe Basin!!!!</li>
           <li>Dinner at Sunday Vinyl</li>
         </ul>
       </div>
       </div>
     
  
</div>

<div className="dentistProfile">
     
     <div className="dentistLeft">
       <img 
         src={doctor3}
         alt="Dr. Steven Zervas" 
         className="profileImage" 
       />
     </div>

     <div className="dentistRight">
     <div className="dots"></div>
       <h2 className="name">Dr. Steven Zervas</h2>
       <p className="question">Why dentistry?</p>
       <p className="bio">
         I’m a dentist because it has always been my desire to help people in a healthcare environment. 
         Growing up in my dad’s and uncle’s dental office, I learned early on that dentistry was going to 
         be my path. I love the relationships we build with our patients and our ability to help them live 
         healthier, better lives.
       </p>
       </div>
    

     <div className="educationRight">
       <div className="educationSection">
         <h3>Education</h3>
         <ul>
           <li>BA in Biology and World Religions, Westminster College</li>
           <li>DDS, University of Oklahoma</li>
         </ul>
         
         <h3>Out and about in Denver/Greenwood Village</h3>
         <ul>
           <li>Running in Wash Park</li>
           <li>Concerts at the Mission Ballroom and Red Rocks</li>
           <li>Telemark skiing at Arapahoe Basin!!!!</li>
           <li>Dinner at Sunday Vinyl</li>
         </ul>
       </div>
       </div> */}
     
  
{/* </div> */}
<div className="dental-bar-menu" style={{ margin: " 0 0px",backgroundColor:"white" }}>
      <h2 className="menu-title" style={{ textAlign: "center",  color: " black" }}>
        Bombay Dental Company Menu
      </h2>
      <Slider {...sliderSettings}>
        {barItems.map((item, index) => (
          <div key={index} className="menu-item" style={{ textAlign: "center", height:"100%"}}>
            <div className="icon" style={{ marginBottom: "10px" ,color: " #0047AB"}}>
              {item.icon}
            </div>
            <p className="label" style={{ color: " #0047AB" }}>
              {item.label}
            </p>
          </div>
        ))}
      </Slider>
    </div>
    <div className="visit-us-container">
  <div className="images-container">
    <img src={dental1} alt="Waiting Area" className="image-item" />
    <img src={dental2} alt="Exam Room" className="image-item" />
    <img src={dental3} alt="Sign" className="image-item" />
    <img src={dental4} alt="Lounge" className="image-item" />
  </div>
  <div className="info-container">
    <h1 className='visit'>Visit Us</h1>
    <p className='weare'>
      We are conveniently located right on the Worli Naka, on the first floor of Atur House, opposite the Bharat Petroleum Pump. Our guards are very helpful, and free parking is provided easily upon asking.
    </p>
    <div className="lhflex">

    <div className="location">
      <h1 className='tp'><IoLocationOutline /></h1>
      <p> Bombay Dental Company<br />
        Atur House<br />
        First Floor, Flat no 2<br />
        Worli Naka, Worli<br />
        Mumbai 400018
      </p>
      <a href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018" className="directions-link" target="_blank" rel="noopener noreferrer">Get Directions</a>
    </div>
    <div className="hours">
      <h1 className='tp'><IoTimeOutline /></h1>
      <p> Mon-Sat 9 am – 7 pm<br />
        Sun 10 am – 2 pm<br />
        Thursday off
      </p>
    </div>
    </div>
  </div>
  <div className="map-container">
  <iframe
  src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
  width="100%"
  height="450"
  style={{ border: "8px",borderRadius:"18px "}}
  allowFullScreen
  loading="lazy"
  title="Google Maps Location of Bombay Dental Company"/>
  </div>
</div>

    <div className="home-sec8">
    <div className="book-visit-container">
      <div className="online">
     
        <h1 className='book'>Book your visit online</h1>
        <p className='view'>Book your visit online and enjoy our unique No-wait policy, so that you have time for what you enjoy, and not spend your precious time in the doctor’s waiting area.
A few lucky callers every month will be randomly shortlisted for a free scaling and polishing session.</p>
<a href="/booknow" ><button className="book-button1">BOOK ONLINE</button></a>
      </div>
    </div>
    </div>

    </div>
  )
}

export default Meet
